// CoreUI's fixed header/sidebar use z-index 1020/1019, above Vuetify's default
// dialog stack (202); wide dialogs would slide under the sidebar. Same fix as
// StammdatenImportDialog: lift the dialog (ref "dialog", or the given ref)
// and its overlay.
export default {
  watch: {
    visible (v) {
      if (v) {
        this.raiseStack()
      }
    },
  },
  methods: {
    raiseStack (ref = 'dialog') {
      const dialog = this.$refs[ref]
      if (!dialog) {
        return
      }
      dialog.stackMinZIndex = 1030
      this.$nextTick(() => {
        if (dialog.overlay && dialog.activeZIndex) {
          dialog.overlay.zIndex = String(dialog.activeZIndex - 1)
        }
      })
    },
  },
}
